import { render, staticRenderFns } from "./OrderPaymentDownload.vue?vue&type=template&id=444c4a5a&scoped=true&"
import script from "./OrderPaymentDownload.vue?vue&type=script&lang=js&"
export * from "./OrderPaymentDownload.vue?vue&type=script&lang=js&"
import style0 from "./OrderPaymentDownload.vue?vue&type=style&index=0&id=444c4a5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444c4a5a",
  null
  
)

export default component.exports